import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { Catalog } from 'src/app/core/interfaces/catalog';
import { environment } from '../../../../environments/environment';
import { Cargo, RequestUpdateBody } from 'src/app/core/interfaces/cargo';
import { DiscountsAndBonuses } from 'src/app/core/interfaces/discountsAndBonuses';
import { Payments } from 'src/app/core/interfaces/payments';
import { BasicResponse } from 'src/app/core/interfaces/basicResponse';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { CompanyManager } from 'src/app/core/managers/company.manager';
import { Fmt } from 'src/app/core/messages/fmt';
import { Utils } from 'src/app/core/resources/utils';
import { CargoConsignment } from 'src/app/core/interfaces/cargoEditConsignment';
import { ShippingCost } from 'src/app/core/interfaces/shippingCost';
import { AdditionalCostDeleted } from 'src/app/core/interfaces/additionalCostDeleted';
import { UploadDownload } from 'src/app/core/interfaces/uploadDownload';
import { ConsignmentCargo } from 'src/app/core/interfaces/consignmentCargo';
import { map } from 'rxjs/operators';
import { LogisticTime } from 'src/app/core/interfaces/durationTime';

import { ConsignmentDetailField } from 'src/app/core/managers/consignment.manager';
import { ConsignmentManager } from 'src/app/core/managers/consignment.manager';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { ConsignmentCargoUpdateRNDC } from 'src/app/core/interfaces/consignmentCargo';
import { VehicleInspect } from 'src/app/core/interfaces/vehicleInspect';
import { InspectionQuestion } from 'src/app/core/interfaces/inspectionVehicle';
import { SatelliteLockInspection } from 'src/app/core/interfaces/satelliteLockInspection';
import { Fingerprint } from 'src/app/core/interfaces/fingerprint';
import { FreightCostFingerprintHistory } from 'src/app/core/interfaces/freightCostFingerprintHistory';
import { FingerprintHistory, FingerprintHistoryDTO, FingerprintHistoryDTOMultiple } from 'src/app/core/interfaces/fingerprintHistory';
interface CargoValidation {
  uploadDownload: UploadDownload;
  showMessages: boolean;
  ministry: boolean;
  tripType: string;
}
@Injectable({
  providedIn: 'root'
})
export class CargoDetailService {

  permission = Permission;

  constructor(
    private _http: HttpClient,
    private _endpointResources: Endpoints,
    private companyManager: CompanyManager,
    public snackBarService: SnackBarService,
    private permissionRole: PermissionRole,
    private utils: Utils,
    private consignmentManager: ConsignmentManager,
    public dialog: MatDialog
  ) { }

  public acceptCargo(params) {

    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.urlAcceptCargo,
      params
    );
  }

  public refuseCargo(params) {

    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.urlRefuseCargo,
      params
    );
  }

  public negotiationCargo(params) {

    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.urlNegotiateCargo,
      params
    );
  }

  public requestCargo(idCargo: string): Observable<Cargo> {
    return this._http.post<Cargo>(
      environment.urlServerTeclogi + this._endpointResources.urlValidateRequestCargo + idCargo, null
    )
  }

  public addObservation(observation: any, idCargo: string) {

    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.addObservation + idCargo,
      observation
    );
  }

  public negotiationRequest(action: string, params) {

    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.urlNegotiateRequestSubCompany}${action}`,
      params
    );
  }

  public cancelCargo(params) {

    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.urlCancelCargo,
      params
    );
  }

  public removeCargo(idCargo, data, hasPaymentsAndPermission = false, removeAll: boolean = false) {
    let url = environment.urlServerTeclogi + this._endpointResources.urlRemoveCargo + idCargo;
    if (hasPaymentsAndPermission) url += '&deleteWithPayment=true'
    if (removeAll) url += '&deleteAllConsolidated=true'
    return this._http.delete(
      url,
      data
    );
  }


  public disassociate(idsCargo, type) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updateCargo + "/" + type,
      {
        'cargoId': idsCargo,
        'type': "Delete"
      }
    );
  }

  public fulFillCargosRndc(body: { cargoConsecutives: number[] }): Observable<{ cargos: Cargo[], failedCargoConsecutives: { consecutive: number, errorMessage: string }[] }> {
    return this._http.post<{ cargos: Cargo[], failedCargoConsecutives: { consecutive: number, errorMessage: string }[] }>(
      environment.urlServerTeclogi + this._endpointResources.fulFillCargosRndc,
      body
    );
  }

  public editInvoice(idsCargo, type, value) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updateCargo + "/" + type,
      {
        'cargoId': idsCargo,
        'type': "Update",
        "value": value
      }
    );
  }
  public detailCargo(idCargo: string): Observable<Cargo> {
    return this._http.get<Cargo>(
      environment.urlServerTeclogi + this._endpointResources.urlDetailCargo + idCargo
    );
  }

  public detailCargoByConsecutive(consecutive: string) {
    return this._http.get<Cargo>(
      environment.urlServerTeclogi + this._endpointResources.urlDetailCargoByConsecutive + consecutive
    );
  }

  public detailServiceRequestByConsecutive(consecutive: string) {
    const headers = new HttpHeaders().set('companyId', '9002585606');
    let params = new HttpParams();
    params = params.append('cargoHolderId', '9002585606');
    return this._http.get(
      `${environment.urlServerTeclogi}${this._endpointResources.urlCargoServiceRequestsDetail}/${consecutive}`, { headers, params }
    );
  }



  public getGuideStates() {
    return this._http.get<Catalog>(
      environment.urlServerTeclogi + this._endpointResources.urlCatalog + '/GuideState'
    );
  }

  public setGuideStates(guideId: string, state: string, nit: string, date: string) {
    let params = new HttpParams();
    params = params.append('companyId', nit);
    params = params.append('state', state);
    params = params.append('guideId', guideId);
    params = params.append('date', date);
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.setGuideStateFalabella,
      {},
      { params }
    );
  }

  public updateFreightForwarder(data) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updateCargo,
      data
    );
  }

  public updateCargo(data) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updateCargo,
      data
    );
  }

  public completeUpdateRequest(data, realCargo: Cargo) {
    const keys = [
      'driver', 'licensePlate', 'observation', 'observationDriver', 'dateLoad', 'shippingCost', 'simpleRegimen', 'manifestError',
      'errorFieldsExcelCargo', 'cargoModel', 'cargoFeature', 'container', 'containers', 'containerExpirationDate',
      'seal', 'booking', 'numberDocumentSender', 'ministry', 'cargoOwner', 'idCompany', 'estimatedTime', 'distancy'
    ];
    const newCargo: RequestUpdateBody = {
      id: realCargo.id,
      state: realCargo.state,
      dateLoad: realCargo.dateLoad,
      shippingCost: realCargo.shippingCost,
    };

    keys.forEach((key) => {
      if (key in data)
        newCargo[key] = data[key];
      else
        newCargo[key] = this.utils.getNestedValue(realCargo, key);
    });

    if (this.utils.getNestedValue(newCargo, 'cargoFeature.uploadDownload.origin.addresses'))
      newCargo.cargoFeature.uploadDownload.origin.addresses.forEach((address) => {
        if (address['idTracking'])
          delete address['idTracking'];
      });

    if (this.utils.getNestedValue(newCargo, 'cargoFeature.uploadDownload.destination'))
      newCargo.cargoFeature.uploadDownload.destination.forEach((destination) => {
        if (destination && destination.addresses)
          destination.addresses.forEach((address) => {
            if (address['idTracking'])
              delete address['idTracking'];
          });
      });

    return this.updateRequest(newCargo);
  }

  private updateRequest(data: RequestUpdateBody) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updateRequest,
      data
    );
  }
  public updateLoadDownload(data, idCargo) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updateLoadDownload + idCargo, data
    );
  }

  public getRouteGoogleCargo(idCargo: string) {
    return this._http.get(
      environment.urlServerTeclogi + this._endpointResources.getRouteGoogleCargo + idCargo
    );
  }

  public saveRouteGoogleCargo(routeGoogle) {
    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.saveRouteGoogleCargo,
      routeGoogle
    );
  }

  public getCargoPDF(pdfType: string, cargoId: string) {
    let params = new HttpParams();
    params = params.append('pdfType', pdfType);
    params = params.append('cargoId', cargoId);
    return this._http.get(
      environment.urlServerTeclogi + this._endpointResources.cargoPDF,
      { params, responseType: 'blob' }
    );
  }

  public getHistoryDiscountsAndBonuses(cargo: Cargo, type: number, category?: 'amount' | 'amountRate'): DiscountsAndBonuses[] {
    if (cargo.shippingCost && cargo.shippingCost.modifications) {
      const history = cargo.shippingCost.modifications.filter((item) => {
        return item.type === type;
      });
      if (category) return history.filter((item) => category === 'amount' ? !!item.amount : !!item.amountRate);
      return history;
    }
    return [];
  }

  public getHistoryDiscountsAndBonusesAdditionalServices(additionalServiceGroupCtrl, type: number): DiscountsAndBonuses[] {
    if (additionalServiceGroupCtrl && additionalServiceGroupCtrl.financialInformation && additionalServiceGroupCtrl.financialInformation.modifications) {
      return additionalServiceGroupCtrl.financialInformation.modifications.filter((item) => {
        return item.type === type;
      });
    }
    return [];
  }

  public getHistoryPaid(cargo: Cargo): Payments[] {
    if (cargo.shippingCost && cargo.shippingCost.payments) {
      return cargo.shippingCost.payments.filter((item) => {
        return item;
      });
    }
    return [];
  }

  public cancelManifest(data: { manifestNumber: string, observations: string, isNational: boolean }) {
    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.cancelManifest}`,
      data
    );
  }

  public createAndEmitConsignment(data: { cargoId: string, emitToRndc: boolean, updateCargoState: boolean, consignment: ConsignmentCargo }) {
    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.createAndEmitConsignment}`,
      data
    );
  }

  public cancelConsignment(data: { consignmentNumber: string, observations: string, isNational: boolean }) {
    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.cancelConsignment}`,
      data
    );
  }

  public addAdditionalcost(cargoId: string, body): Observable<BasicResponse> {
    let params = new HttpParams();
    params = params.append('cargoId', cargoId);
    return this._http.post<BasicResponse>(
      environment.urlServerTeclogi + this._endpointResources.addAdditionalcost,
      body,
      { params }
    );
  }

  public updateAdditionalcost(cargoId: string, body): Observable<BasicResponse> {
    let params = new HttpParams();
    params = params.append('cargoId', cargoId);
    return this._http.post<BasicResponse>(
      environment.urlServerTeclogi + this._endpointResources.updateAdditionalcost,
      body,
      { params }
    );
  }

  public updatecargoFeature(idCargo, newData) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updatecargoFeature + idCargo,
      newData
    );
  }

  public deletedAdditionalCosts(idCargo: string) {
    return this._http.get<{ cargoId: string, additionalCostsDeleted: AdditionalCostDeleted[] }>(
      `${environment.urlServerTeclogi}${this._endpointResources.deletedAdditionalCosts}?cargoId=${idCargo}`
    )
  }

  public deletedBonusAndDiscounts(idCargo: string) {
    return this._http.get<DiscountsAndBonuses[]>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.deletedBonusAndDiscounts, idCargo)}`
    )
  }

  public deletedPayments(idCargo: string) {
    return this._http.get<DiscountsAndBonuses[]>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.deletedPayments, idCargo)}`
    )
  }


  public getSatelliteLockInspection(cargoId: string, inspectionType = 'SatelliteLock') {
    let params = new HttpParams();
    params = params.append('cargoId', cargoId);
    params = params.append('inspectionType', inspectionType);
    return this._http.get<SatelliteLockInspection>(
      `${environment.urlServerTeclogi}${this._endpointResources.satelliteLockInspection}`,
      { params }
    );
  }

  getUtilityCargo(cargo: Cargo) {
    const rate = this.utils.getNestedValue(cargo, 'shippingCost.rate') ? cargo.shippingCost.rate : 0;
    const totalCost = this.utils.getNestedValue(cargo, 'shippingCost.totalCost') ? cargo.shippingCost.totalCost : 0;
    if (!rate) return 0;
    return Math.round(((rate - totalCost) / rate) * 100);
  }

  hasPermissionNoMinimumUtility(cargo) {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.createCargosWithoutMinimumUtility
    )
      && cargo.cargoModel.tripType.name === "Urbana"
      && cargo.cargoFeature.productType.name === "CONTENEDOR VACIO";
  }

  public updateCargoLabels(idCargo, newData) {
    return this._http.put(
      environment.urlServerTeclogi + this._endpointResources.updateCargoLabels + idCargo,
      newData
    );
  }

  public updateCargoZone(cargoId: string, zone: 'private' | 'public'): Observable<Cargo> {
    return this._http.put<Cargo>(
      `${environment.urlServerTeclogi}${this._endpointResources.cargoPublishZone}?cargoId=${cargoId}&zone=${zone}`, {}
    );
  }

  public generateManifest(cargoId: string) {
    let params = new HttpParams();
    params = params.append('cargoId', cargoId);
    return this._http.get<Cargo>(
      `${environment.urlServerTeclogi}${this._endpointResources.rebuildManifest}`,
      { params }
    );
  }

  public updateShippingCost(shippingCost: ShippingCost, cargoId: string) {
    return this._http.put(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.updateShippingCost, cargoId)}`,
      shippingCost
    );
  }

  public reduceFreightCost(cargoId: string, freightCost: number): Observable<BasicResponse> {
    return this._http.put<BasicResponse>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.reduceFreightCost, cargoId)}`,
      freightCost
    );
  }

  public getFingerPrintHistory(cargoId: string, fingerprintType: string): Observable<FingerprintHistory[]> {
    let params = new HttpParams();
    params = params.append('type', fingerprintType);
    return this._http.get<FingerprintHistory[]>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.fingerprintHistoryByType, cargoId)}`,
      { params }
    );
  }

  public saveFingerprintHistory(cargoId: string, fingerprintHistory: FingerprintHistoryDTO): Observable<FingerprintHistory> {
    return this._http.post<FingerprintHistory>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.saveFingerprintHistoryIndividual, cargoId)}`,
      fingerprintHistory
    );
  }

  public deleteAssignedVehicle(cargoId: string) {
    return this._http.delete(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.deleteAssignedVehicle, cargoId)}`
    );
  }

  public getCargoConsignments(cargoId: string, state?: string): Observable<ConsignmentCargo[]> {
    let params = new HttpParams();
    params = params.append('cargoId', cargoId);
    if (state) params = params.append('state', state);
    return this._http.get<ConsignmentCargo[]>(
      `${environment.urlServerTeclogi}${this._endpointResources.getAllCargoConsignments}`,
      { params }
    );
  }

  public createConsignment(consignments: ConsignmentCargo[]) {
    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.cargoConsignments}`,
      consignments
    );
  }

  public authorizeCargoWithoutConsignment(cargoId: string): Observable<Cargo> {
    return this._http.post<Cargo>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.authorizeCargoWithoutConsignment, cargoId)}`,
      {},
    );
  }

  public authorizeCargoWithoutManifest(cargoId: string): Observable<Cargo> {
    return this._http.post<Cargo>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.authorizeCargoWithoutManifest, cargoId)}`,
      {},

    );
  }

  public updatePrevalidation(cargoId: string, prevalidation: { valid: boolean; observation?: string }): Observable<Cargo> {
    return this._http.put<Cargo>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.cargoPrevalidation, cargoId)}`,
      prevalidation
    );
  }

  public updateConsignments(consignments: ConsignmentCargo[]) {
    return this._http.put(
      `${environment.urlServerTeclogi}${this._endpointResources.cargoConsignments}`,
      consignments
    );
  }

  public deleteConsignment(documentId: string, cargoId: string) {
    let params = new HttpParams();
    params = params.append('documentId', documentId);
    params = params.append('cargoId', cargoId);
    return this._http.put(
      `${environment.urlServerTeclogi}${this._endpointResources.consignmentSoftDelete}`,
      {},
      { params }
    );
  }

  public updateConsignmentRNDC(consignment: ConsignmentCargoUpdateRNDC) {
    return this._http.put(
      `${environment.urlServerTeclogi}${this._endpointResources.consignmentUpdateRNDC}`,
      consignment,
    );
  }

  public getCargoLogisticTimes(cargoId: string): Observable<LogisticTime[]> {
    return this._http.get<LogisticTime[]>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.cargoLogisticTimes, cargoId)}`
    );
  }

  public updateCargoLogisticTimes(cargoId: string, logisticTime: LogisticTime): Observable<LogisticTime> {
    return this._http.put<LogisticTime>(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.cargoLogisticTimes, cargoId)}`,
      logisticTime
    );
  }

  public getManifestTypes(): Observable<Catalog> {
    return this._http.get<Catalog>(
      `${environment.urlServerTeclogi}${this._endpointResources.urlCatalog}/ManifestTypes`
    );
  }

  public async getConsignments(id: string, state: string) {
    const cargoConsignments: { [key: string]: ConsignmentCargo } = {};
    let consignments: ConsignmentCargo[] = [];
    try { consignments = await this.getCargoConsignments(id, state).toPromise() } catch (error) { }
    if (!consignments || !consignments.length) return;
    consignments.forEach(consignment => cargoConsignments[consignment.id] = consignment);
    return cargoConsignments;
  }

  public updateConsignmentFieldsAndAlerts(cargo: Cargo, cargoConsignments: { [key: string]: ConsignmentCargo }) {
    const cargoConsignmentsFields: { [key: string]: ConsignmentDetailField[] } = {};
    const cargoConsignmentsAlerts: { [key: string]: string } = {};
    const destinations = this.utils.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
    if (destinations && destinations.length) {
      for (let indexDestination = 0; indexDestination < destinations.length; indexDestination++) {
        const destination = destinations[indexDestination];
        if (!destination || !destination.addresses || !destination.addresses.length) continue;
        for (let indexAddress = 0; indexAddress < destination.addresses.length; indexAddress++) {
          const address = destination.addresses[indexAddress];
          if (!address || !address.consignments || !address.consignments.length) continue;
          address.consignments.forEach((consignment: string) => {
            if (consignment && cargoConsignments[consignment]) {
              cargoConsignmentsFields[consignment] = this.consignmentManager.getConsignmentDetailFields(
                cargo, cargoConsignments[consignment], indexDestination, indexAddress);
              cargoConsignmentsAlerts[consignment] = this.consignmentManager.getAlerts(
                cargo, cargoConsignments[consignment], indexDestination, indexAddress);
            }
          });
        }
      }
    }
    return { cargoConsignmentsFields, cargoConsignments, cargoConsignmentsAlerts }
  }

  public async dialogConsignmentAlerts(cargoConsignmentsAlerts: { [key: string]: string }, type: 'manual' | 'automatic' = 'manual', consecutive?: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `${type === 'manual' ? 'No se puede generar manifiesto' : 'No puedes iniciar el servicio'}`,
      description: `Para ${type === 'manual' ? 'generar el manifiesto' : 'iniciar el servicio'} , primero debes resolver los errores en las remesas asociadas ${consecutive ? 'al servicio ' + consecutive : ''}.`,
      descriptionHTML: this.generateAlertsHTML(cargoConsignmentsAlerts),
      hideCancelButton: true,
      hideBtnConfirm: true
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.dialog.open(
      DialogComponent,
      dialogConfig
    );
  }

  private generateAlertsHTML(cargoConsignmentsAlerts: { [key: string]: string }): string {
    let html = '<div class="alerts-container">';
    for (const [key, value] of Object.entries(cargoConsignmentsAlerts)) {
      if (value) {
        html += `
          <div class="alert-item" style="margin-bottom: 12px; padding: 8px; border-left: 3px solid #f44336; background-color: #ffeef0;">
            <div style="margin-bottom: 4px;">
              <strong style="color: #d32f2f; font-weight: 600;">${key}:</strong>
            </div>
            <div style="color: #495356; font-size: 14px; line-height: 1.4;">
              ${value}
            </div>
          </div>
        `;
      }
    }
    html += '</div>';
    return html;
  }

  public assignLock(cargoId: string, imei?: string): Observable<any> {
    return this._http.put(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.assignLock, cargoId)}`,
      { imei }
    );
  }


  public saveSatelliteLockInspection(
    cargoId: string,
    inspectionData: {
      imei: string;
      version: number;
      satelliteLockStructure: Array<{ question: string; response: string }>;
    }
  ): Observable<unknown> {
    let params = new HttpParams();
    params = params.append('inspectionType', 'SatelliteLock');
    params = params.append('cargoId', cargoId);

    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.satelliteLockInspection}`,
      inspectionData,
      { params }
    );
  }


  public approveSatelliteLockInspection(
    inspectionId: string
  ): Observable<unknown> {
    let params = new HttpParams();
    params = params.append('approval', 'true');
    params = params.append('inspectionId', inspectionId);
    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.satelliteLockInspection}/approval`,
      {},
      { params }
    );
  }
}
